import empty_box from "../../../images/empty_box.png";
import { useQuery } from "@tanstack/react-query";

import {
  getMe,
} from "../../../api";
import ConvertToArabicNumbers from "../../../utils/convert_numbers";
import Skelton from "../../../icons/skelton";
import {useNavigate} from 'react-router-dom'


function AuctionsInputs() {
  const navigator = useNavigate();
  const {
    data: myOffers,
    isFetching:offersFetching,
    refetch,
  } = useQuery({
    queryKey: ["my_offers"],
    queryFn: () => getMe(),
    initialData: [],
  });


  const getAuction = (id) => {
    navigator(`/home/single_auction/${id}`);
  };

if (offersFetching) {
  return (
    <div
      dir="rtl"
      className="my-16 grid grid-cols-1 gap-4 px-0 lg:grid-cols-5 lg:mr-8"
    >
      {[...Array(5).keys()].map((e, i) => (
        <Skelton key={i} />
      ))}
    </div>
  );
}

  return (
    <div className="my-10 px-5 lg:px-7">
      <h1 className="text-end font-bold text-[24px] my-10">
     المزادات
      </h1>
      {myOffers?.auctions?.length === 0 ? (
        <div className="flex flex-col h-72 -span-2 mt-10 justify-center items-center text-center lg:col-span-5">
          <div>
            <img src={empty_box} alt=""></img>
          </div>
          <div className="font-bold mt-3">لا توجد مدخلات</div>
          <div className="h-10"></div>
        </div>
      ) : (
        <div className="flex flex-wrap gap-3 flex-row-reverse">
          {myOffers?.auctions?.map((item) => (
            <div
              className="relative flex flex-row-reverse lg:flex-col items-center justify-evenly overflow-hidden w-full   lg:w-[13rem] lg:min-w-[13rem]  bg-white border-2 border-primary rounded-2xl  h-[8rem]  lg:h-72 min-w-full lg:text-2xl"
              key={item.id}
              onClick={() => (!item.verified ? "" : getAuction(item.id))}
            >
              {!item.verified ? (
                <div className="absolute top-1 text-sm font-bold bg-gray-200 px-2 rounded-full">
                  قيد المعاينة
                </div>
              ) : (
                ""
              )}

              <img
                src={item._sub_category.image}
                className="lg:h-2/4  max-w-[108px]  lg:max-w-full mt-2"
                alt=""
              />
              <div className="flex row items-center" dir="rtl">
                <div className="font-bold text-lg my-1">
                  {item._sub_category.name}
                </div>
              </div>
              <div
                className="lg:text-lg text-md mb-0.5"
                dir="rtl"
              >{`${ConvertToArabicNumbers(item.quantity)} ${
                item._unit.name
              }`}</div>
              <div className="text-lg mb-1">{item._state.name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AuctionsInputs;
